import React from 'react'
import FormEdit from '../../common/CommonComponents/FormEdit';
import spinner from '../../../assets/icons/loading.gif'
import validImg from '../../../assets/icons/check.png'
import invalidImg from '../../../assets/icons/wrong.png'
import axios from 'axios';
import base from "../../../config";
import { useState } from 'react';
import moment from 'moment/moment';
import { useEffect } from 'react';
import { useRef } from 'react';

export default function UpdateTags({ show,
    title,
    width,
    height,
    setShow,
    data,
    saveDisabled,
    saveFunction,
    updateData,
    setConfirm
}) {
    const initRun = useRef(false);
    const itemData = data;
    //copy test
    const timeoutRef = useRef(null);
    const visible = show || false;
    const titleText = title || "Welcome";
    const dspWidth = width || "600px";
    const dspHeight = height || "80%";
    const setVisble = setShow || null;
    const wbseRef = useRef(null);
    const contractidRef = useRef(null);
    //for the sap id
    const [toogleSap, setToogleSap] = useState(true);
    const [sapValid, setSapValid] = useState(true);
    const [EndtoEndID, setEndtoEndID] = useState('');
    const [ClientName, setClientName] = useState('');
    const [wbseValid, setWbseValid] = useState(true);
    const [newPdata, setnewPdata] = useState({});

    const newData = {
        'caasid': itemData.caas_id,
        'customerEnterpriseId': itemData.caas_customerEID,
        'secondaryPOC': itemData.caas_secondaryPOC,
        'environment': itemData.caas_environment,
        'initiative': itemData.caas_intiative,
        'wbseCode': itemData.caas_wbsecode,
        'serviceEndDate': itemData.caas_sed,
        'projectName': itemData.caas_projectName,
        'contractId': itemData.caas_contractID,
        'notes': itemData.caas_notes,
        'orderid': itemData.caas_orderItemUid,
        'ceid': itemData.caas_customerEID,
        'appcore': itemData.caas_appcore,
        'dcr': itemData.caas_dcr,
        'clientName': '',
        'endtoenduid': ''
    };

    const idToken = localStorage.getItem("token");
    const urloptions = {
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
            "Authorization": idToken,
        }
    };

    const onChange = (event) => {
        const { name, value } = event.target;
        if (!initRun.current) {
            initRun.current = true;
            setnewPdata({
                ...newData,
                [name]: value
            });
        } else {
            setnewPdata(prev => ({
                ...prev,
                [name]: value
            }));
        }

        if (name === "wbseCode") {

            event.target.style.backgroundImage = `url("${spinner}")`;
            if (value === "") {
                setWbseValid(false);
                event.target.style.backgroundImage = `url("")`;
                return;
            }

            const inputValid = /(?=^.{8}$)(?=(.*[a-zA-Z]){1,6})(?=(.*[0-9]){2,7})/.test(value);
            if (!inputValid) {
                setWbseValid(false);
                event.target.style.backgroundImage = `url("${invalidImg}")`;
                return;
            }
            validateWbsecode(value);
        } else if (name === "contractId") {
            event.target.style.backgroundImage = `url("${spinner}")`;
            if (value === "") {
                setSapValid(false);
                event.target.style.backgroundImage = `url("")`;
                return;
            }

            const inputValid = /^\d{10}$/.test(value);
            if (!inputValid) {
                setSapValid(false);
                event.target.style.backgroundImage = `url("${invalidImg}")`;
                return;
            }
            validateContract(value);
        }
    }

    const updateTags = () => {
        setConfirm({
            appName: 'gwConfirm',
            config: {
                stateFunction: setConfirm,
                text: (<>Are you sure want to Update Tags</>),
                onloop: true,
                width: 360,
                height: 190,
                bntYes: () => {
                    saveFunction(newPdata);
                }
            },
        });
    }

    const maxDateInput = (selectedEnvironmentValue) => {
        let maxDate;
        const getMaxDate = (date) => {
            const maxDateEnv = moment()
                .add(date, "days")
                .format("YYYY-MM-DD");
            return maxDateEnv;
        };

        if (selectedEnvironmentValue === "Dev") {
            maxDate = getMaxDate(28);
        } else if (selectedEnvironmentValue === "Test") {
            //cannot find how to get configuration type brb on this function
            maxDate = getMaxDate(1826);
        } else if (selectedEnvironmentValue === "Sales") {
            maxDate = getMaxDate(60);
        } else if (selectedEnvironmentValue === "Production") {
            maxDate = getMaxDate(1826);
        }
        return maxDate
    };

    //check the sap on the DB if valid
    const validateWbsecode = async (wbseCode) => {
        const urls = `${base.urls.apis.fulfillment}/wbs_validate`;
        await axios.get(urls, {
            ...urloptions,
            params: {
                WBSEcode: wbseCode,
            },
        }).then((resp) => {
            if (resp.data !== 'false') {
                setWbseValid(true);
                wbseRef.current.style.backgroundImage = `url("${validImg}")`;
                setnewPdata(prev => ({
                    ...prev,
                    ['wbseCode']: wbseCode,
                }));
            } else {
                setWbseValid(false);
                wbseRef.current.style.backgroundImage = `url("${invalidImg}")`;
            }
        }).catch((err) => {
            console.log(err)
            setWbseValid(false);
        });
    };
    //check the sap on the DB if valid
    const validateContract = async (contractId) => {
        const urls = `${base.app.apiSite}fui/client-details`;
        await axios.get(urls, {
            ...urloptions,
            params: {
                contract_code: contractId,
            },
        }).then((resp) => {
            if (resp.data[0] !== 'N/A') {
                setSapValid(true);
                setClientName(resp.data[0]);   // value added
                setEndtoEndID(resp.data[1]);
                // setnewPdata({
                //     ...newData,
                //     ['contractId']: contractId
                // });
                setnewPdata(prev => ({
                    ...prev,
                    ['contractId']: contractId,
                    ['clientName']: resp.data[0],
                    ['endtoenduid']: resp.data[1]
                }));
                contractidRef.current.style.backgroundImage = `url("${validImg}")`;
            } else {
                setSapValid(false);
                contractidRef.current.style.backgroundImage = `url("${invalidImg}")`;
            }
        }).catch((err) => {
            console.log(err);
            setSapValid(false);
        });
    };

    useEffect(() => {
        if (show) {
            setSapValid(true);
            setWbseValid(true);
        }
    }, [show]);

    return (
        <FormEdit show={visible} title={titleText} width={dspWidth} height={dspHeight} setShow={setVisble} saveDisabled={(sapValid && wbseValid) ? false : true} saveFunction={updateTags}>
            <div style={{ fontSize: '.9rem' }}>
                <form id='editTags' className='formDataEdit'>
                    <div className='formInputs'>
                        <label>Customer Enterprise ID:</label>
                        <input type="text" name="customerEnterpriseId" defaultValue={newData.customerEnterpriseId} onChange={onChange} />
                    </div>
                    <div className='formInputs'>
                        <label>Secondary POC:</label>
                        <input type="text" name="secondaryPOC" defaultValue={newData.secondaryPOC} onChange={onChange} />
                    </div>
                    <div className='formInputs'>
                        <label>Environment:</label>
                        <select type="text" name="environment" defaultValue={newData.environment} onChange={onChange}>
                            <option value="production">Production</option>
                            <option value="dev">Dev</option>
                            <option value="uat">Uat</option>
                            <option value="sales">Sales</option>
                            <option value="test">Test</option>
                        </select>
                    </div>
                    <div className='formInputs'>
                        <label>Initiative:</label>
                        <select type="text" name="initiative" defaultValue={newData.initiative} onChange={onChange}>
                            <option value="Agile Capability">Agile Capability</option>
                            <option value="Change Enablement">Change Enablement</option>
                            <option value="FORM, Methods & Estimators">FORM, Methods & Estimators</option>
                            <option value="Language Translation Services">Language Translation Services</option>
                            <option value="Living Systems Advisory">Living Systems Advisory</option>
                            <option value="1AAA">1AAA</option>
                            <option value="DevOps Capability">DevOps Capability</option>
                            <option value="ICS">ICS</option>
                            <option value="IEMP">IEMP</option>
                            <option value="myDiagnostic">myDiagnostic</option>
                            <option value="myIndustry">myIndustry</option>
                            <option value="myMDI">myMDI</option>
                            <option value="myNav">myNav</option>
                            <option value="mySP">mySP</option>
                            <option value="myWizard Apps">myWizard - Other Apps</option>
                            <option value="myWizard AI Apps">myWizard AI Apps</option>
                            <option value="myWizard_AiOps">Mywizard AiOps</option>
                            <option value="myWizard Governance">Mywizard Governance</option>
                            <option value="myWizard Platform Mgt">Mywizard Platform Mgt</option>
                            <option value="myWizard SaaS">myWizard SaaS</option>
                            <option value="myWizard SI">myWizard SI</option>
                            <option value="Technical architecture">Technical architecture</option>
                            <option value="Transformation Office">Transformation Office</option>
                            <option value="UX">UX</option>
                            <option value="Automation Deployment">Automation Deployment</option>
                            <option value="Sales & Solutions">Automation Sales & Solution</option>
                            <option value="PMO">PMO</option>
                        </select>
                    </div>
                    <div className='formInputs' style={{ height: wbseValid ? '50px' : '80px' }}>
                        <label>WBSE Code:</label>
                        <input type="text" name="wbseCode" defaultValue={newData.wbseCode} onChange={onChange} ref={wbseRef} /><br />
                        {!wbseValid &&
                            <div className='errorMsg'>WBSE Code is Invalid</div>
                        }
                    </div>
                    <div className='formInputs'>
                        <label>Service End Date:</label>
                        <input type="date" name="serviceEndDate" defaultValue={newData.serviceEndDate} onChange={onChange} min={moment().format("YYYY-MM-DD")} max={maxDateInput(itemData.caas_environment)} />
                    </div>
                    <div className='formInputs'>
                        <label>Project Name:</label>
                        <input type="text" name="projectName" defaultValue={newData.projectName} onChange={onChange} />
                    </div>
                    <div className='formInputs' style={{ height: sapValid ? '50px' : '80px' }}>
                        <label>SAP Contract ID:</label>
                        <input type="text" name="contractId" defaultValue={newData.contractId} onChange={onChange} ref={contractidRef} />
                        {!sapValid &&
                            <div className='errorMsg'>SAP Contract ID is Invalid</div>
                        }
                    </div>
                    <div className='formInputs' style={{ height: '80px' }}>
                        <label>Notes:</label>
                        <textarea type="text" name="notes" onChange={onChange} defaultValue={newData.notes}></textarea>
                    </div>
                </form>
            </div>
        </FormEdit>
    )
}
